export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";

export const createNotification = (notification) => ({type: CREATE_NOTIFICATION, notification});
export const deleteNotification = (notification) => ({type: DELETE_NOTIFICATION, notification});
